import {
  UPDATE_SUB_PRACTICE,
  UPDATE_SUB_PRACTICE_SUCCESS,
  UPDATE_SUB_PRACTICE_FAILURE,
} from 'store/updateSubPractice/updateSubPracticeAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateSubPracticeReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SUB_PRACTICE:
      return { ...state, loading: true };
    case UPDATE_SUB_PRACTICE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_SUB_PRACTICE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateSubPracticeReducer;
